import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { Partner } from '@/openapi';
import { PartnersService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useCreatePartnerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (partner: Partner) => {
      return PartnersService.partnersServiceCreatePartner({ body: partner });
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.partners.all });
    },
  });
};
